export class RCSRepliesModel {
  public rcsReplyId: number;
  public replyDate: string;
  public rcsMessage: string;
  public number: number;

  constructor(init: any) {
    this.rcsReplyId = init.RCSReplyID;
    this.replyDate = init.ReplyDate;
    this.rcsMessage = init.RCSMessageBody;
    this.number = init.Number;
  }
}
